import React from 'react';
import {observable} from 'mobx';
import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import {Modal, ModalButtons} from 'shared/components/modals';
import {toSentence} from 'shared/tools';
import {t} from 'shared/core';
import {FormError, DatePicker, HtmlRender} from 'shared/components';
import {EmployeeSelector} from 'main/components';
import AddAssigneesModalState from 'main/containers/company_settings/documents/state/AddAssigneesModalState';
import _ from 'lodash';

const AddAssigneesForm = observer(({uiState, onHide}) => {
  const {companyDocument, errors} = uiState;

  const otherAssignees = _.transform(_.get(companyDocument, 'sortedAssignmentRules'), (result, rule) => {
    if (rule.isSpecificEmployee) result.push(`<b>${rule.name}</b>`);
    else result.push(`<b>${t("company_settings.documents.each assignee's manager")}</b>`);

    return result;
  }, []);

  return (
    <form>
      <div className='jumbo mb2'>
        <FormattedMessage id='company_settings.documents.Choose who will be assigned this document. Assigned employees will be notified with a task to complete the document.'/>
      </div>
      {otherAssignees.length > 0 &&
        <div className='jumbo mb2'>
          <HtmlRender
            html={
              t('company_settings.documents.OTHER_ASSIGNEES', {
                otherAssignees: toSentence(otherAssignees),
                assigneeCount: otherAssignees.length
              })
            }
          />
        </div>
      }
      <EmployeeSelector onChange={employees => uiState.selectedEmployees = employees} />
      <DatePicker
        label='company_settings.documents.Due Date'
        value={uiState.companyDocumentAssignment.dueDate}
        onChange={date => uiState.setDueDate(date)}
        errorMessage={uiState.errors.dueDate}
        optional
      />
      <FormError message={errors.base} />
      <ModalButtons
        onSave={() => uiState.saveAssignees()}
        onCancel={onHide}
      />
    </form>
  );
});

@observer class AddAssigneesModal extends React.Component {
  @observable uiState;

  async componentDidMount() {
    this.uiState = new AddAssigneesModalState(this.props.companyDocument, this.props.onSuccess);
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(nextProps) {
    this.uiState.companyDocument = nextProps.companyDocument;
    this.uiState.companyDocumentAssignment.merge({companyDocument: nextProps.companyDocument});
  }

  render() {
    const {isOpen, onHide} = this.props;
    const {uiState} = this;

    if (!uiState) return null;

    return (
      <Modal
        size='md'
        isOpen={isOpen}
        onHide={onHide}
        title='company_settings.documents.Assign Document'
      >
        <AddAssigneesForm uiState={uiState} isOpen={isOpen} onHide={onHide}/>
      </Modal>
    );
  }
}

export default AddAssigneesModal;
